export const getMenuList = (list, access) => {
  let arr = []
  list.forEach(item => {
    arr.push(item)
  })
  return arr
}



// WEBPACK FOOTER //
// ./src/libs/util.js